<div class="container-fluid">
    <div class="row">
        <div class="col-md-3">
            <a routerLink="/naac/ssr" *ngIf="showSideMenu"> <i class="fas fa-long-arrow-alt-left"></i> Go Back</a>
            <nav id="secondary-navigation" *ngIf="showSideMenu">
                <!-- Header -->
                <header class="header">
                    <h5>EXTENDED PROFILE</h5>
                </header>
                <!-- /Header -->
                <ul>
                    <li routerLinkActive="active">
                        <a  routerLink="/naac/ssr/extended-profile/1" (click)="checkRoute()">1</a>
                    </li>
                    <li routerLinkActive="active">
                        <a routerLink="/naac/ssr/extended-profile/2" (click)="checkRoute()">2</a>
                    </li>
                    <li routerLinkActive="active">
                        <a routerLink="/naac/ssr/extended-profile/3" (click)="checkRoute()">3</a>
                    </li>
                   
                </ul>
            </nav>
        </div>
        <div [ngClass]="fullWidth ? 'col-md-12' : 'col-md-9'">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>